import React from 'react';
import Dialog from "@mui/material/Dialog";
import {useTranslation} from "react-i18next";
import DialogTitle from "@mui/material/DialogTitle";
import List from "@mui/material/List";
import uuid from "../../utils/uuid";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import DescriptionIcon from '@mui/icons-material/Description';
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import {downloadUrl} from "../../utils/dowloadUrl";
import DialogContentText from "@mui/material/DialogContentText";
import DialogContent from "@mui/material/DialogContent";

const AttachmentDialog = ({open, setOpen, fileAttachments, partAttachments}) => {
    const {t} = useTranslation();
    const handleClose = () => {
        setOpen(false);
    };

    const Attachment = ({attachment}) => {
        const isImage = attachment.Mime.startsWith("image");

        return (
            <ListItem button onClick={() => {
                downloadUrl(attachment.Url_Download ? attachment.Url_Download : attachment.Url)
            }}>
                <ListItemAvatar>
                    {isImage && <Avatar src={attachment.Url}/>}
                    {!isImage && <Avatar>
                        <DescriptionIcon/>
                    </Avatar>}
                </ListItemAvatar>
                <ListItemText primary={attachment.Filename ? attachment.Filename : attachment.Url}/>
            </ListItem>
        )
    };

    return (
        <Dialog onClose={handleClose} aria-labelledby="attachment-dialog-title" open={open}>
            <DialogTitle id="attachment-dialog-title">{t('attachments_title')}</DialogTitle>
            <DialogContent>
                <DialogContentText id="attachment-dialog-desc">
                    {t('attachments_desc')}
                </DialogContentText>
            </DialogContent>
            <List>
                {fileAttachments.map(f => <Attachment key={uuid()} attachment={f}/>)}
                {partAttachments.map(f => <Attachment key={uuid()} attachment={f}/>)}
            </List>
        </Dialog>
    );
};

export default AttachmentDialog;